import React, { useState, useEffect } from 'react';
import  vaccinationService  from '../services/vaccinationService'; // Adjust path as needed

const EditVaccination = ({ vaccination, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    vaccineId: '',
    vaccineName: '',
    patientId: '',
    dateAdministered: '',
    nextDueDate: '',
    doseNumber: 0,
    administrationRoute: '',
    administrationSite: '',
    lotNumber: '',
    manufacturerId: '',
    expirationDate: '',
    administratorId: '',
    status: 'Scheduled',
    notes: '',
    vaccinationId: '',
    isActive: true
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Initialize form with vaccination data
  useEffect(() => {
    if (vaccination) {
      setFormData({
        vaccineId: vaccination.vaccineId || '',
        vaccineName: vaccination.vaccineName || '',
        patientId: vaccination.patientId || '',
        dateAdministered: vaccination.dateAdministered || '',
        nextDueDate: vaccination.nextDueDate || '',
        doseNumber: vaccination.doseNumber || 0,
        administrationRoute: vaccination.administrationRoute || '',
        administrationSite: vaccination.administrationSite || '',
        lotNumber: vaccination.lotNumber || '',
        manufacturerId: vaccination.manufacturerId || '',
        expirationDate: vaccination.expirationDate || '',
        administratorId: vaccination.administratorId || '',
        status: vaccination.status || 'Scheduled',
        notes: vaccination.notes || '',
        vaccinationId: vaccination.vaccinationId || '',
        isActive: vaccination.isActive !== undefined ? vaccination.isActive : true
      });
    }
  }, [vaccination]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Validate required fields
      if (!formData.vaccineId || !formData.patientId) {
        throw new Error('Vaccine ID and Patient ID are required');
      }

      const updatedVaccination = await vaccinationService.updateVaccination(vaccination.id, formData);
      
      if (onSave) {
        onSave(updatedVaccination);
      }

      // Cerrar el modal y refrescar la página
      if (onCancel) {
        onCancel(); // Esto cerrará el modal
      }
      
      // Refrescar la página después de un breve delay para asegurar que el modal se cierre
      setTimeout(() => {
        window.location.reload();
      }, 100);

    } catch (error) {
      console.error('Error updating vaccination:', error);
      setError(error.message || 'Error updating vaccination');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  if (!vaccination) {
    return <div className="alert alert-info">No vaccination selected for editing</div>;
  }

  return (
    <div className="container-fluid p-0">
      <div className="row align-items-center mb-3">
        <div className="col">
          <h3>Edit Vaccination</h3>
        </div>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Vaccination ID</label>
            <input 
              type="text" 
              className="form-control" 
              value={vaccination.id || 'N/A'} 
              readOnly 
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Status <span className="text-danger">*</span></label>
            <select 
              name="status"
              className="form-select" 
              value={formData.status}
              onChange={handleChange}
              required
            >
              <option value="Scheduled">Scheduled</option>
              <option value="Administered">Administered</option>
              <option value="Cancelled">Cancelled</option>
              <option value="Postponed">Postponed</option>
            </select>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Vaccine ID <span className="text-danger">*</span></label>
            <input 
              type="text" 
              name="vaccineId"
              className="form-control" 
              value={formData.vaccineId}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Vaccine Name</label>
            <input 
              type="text" 
              name="vaccineName"
              className="form-control" 
              value={formData.vaccineName}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Patient ID <span className="text-danger">*</span></label>
            <input 
              type="text" 
              name="patientId"
              className="form-control" 
              value={formData.patientId}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Administrator ID</label>
            <input 
              type="text" 
              name="administratorId"
              className="form-control" 
              value={formData.administratorId}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="mb-3">
          <h4>Date Information</h4>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Date Administered</label>
              <input 
                type="date" 
                name="dateAdministered"
                className="form-control" 
                value={formData.dateAdministered}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Next Due Date</label>
              <input 
                type="date" 
                name="nextDueDate"
                className="form-control" 
                value={formData.nextDueDate}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Expiration Date</label>
              <input 
                type="date" 
                name="expirationDate"
                className="form-control" 
                value={formData.expirationDate}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Dose Number</label>
              <input 
                type="number" 
                name="doseNumber"
                className="form-control" 
                value={formData.doseNumber}
                onChange={handleChange}
                min="0"
              />
            </div>
          </div>
        </div>

        <div className="mb-3">
          <h4>Administration Details</h4>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Administration Route</label>
              <select 
                name="administrationRoute"
                className="form-select" 
                value={formData.administrationRoute}
                onChange={handleChange}
              >
                <option value="">Select Route</option>
                <option value="Intramuscular">Intramuscular</option>
                <option value="Subcutaneous">Subcutaneous</option>
                <option value="Intradermal">Intradermal</option>
                <option value="Oral">Oral</option>
                <option value="Nasal">Nasal</option>
              </select>
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Administration Site</label>
              <select 
                name="administrationSite"
                className="form-select" 
                value={formData.administrationSite}
                onChange={handleChange}
              >
                <option value="">Select Site</option>
                <option value="Left Arm">Left Arm</option>
                <option value="Right Arm">Right Arm</option>
                <option value="Left Thigh">Left Thigh</option>
                <option value="Right Thigh">Right Thigh</option>
                <option value="Buttock">Buttock</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <h4>Product Information</h4>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Lot Number</label>
              <input 
                type="text" 
                name="lotNumber"
                className="form-control" 
                value={formData.lotNumber}
                onChange={handleChange}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Manufacturer ID</label>
              <input 
                type="text" 
                name="manufacturerId"
                className="form-control" 
                value={formData.manufacturerId}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="mb-3">
          <h4>Notes</h4>
          <textarea
            name="notes"
            className="form-control"
            rows="3"
            value={formData.notes}
            onChange={handleChange}
            placeholder="Enter any additional notes about the vaccination"
          ></textarea>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Vaccination ID (Internal)</label>
            <input 
              type="text" 
              name="vaccinationId"
              className="form-control" 
              value={formData.vaccinationId}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6 mb-3">
            <div className="form-check mt-4">
              <input 
                className="form-check-input" 
                type="checkbox" 
                name="isActive"
                checked={formData.isActive}
                onChange={handleChange}
                id="isActiveCheck"
              />
              <label className="form-check-label fw-bold" htmlFor="isActiveCheck">
                Active
              </label>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-12">
            <button 
              type="submit" 
              className="btn btn-primary me-2"
              disabled={loading}
            >
              {loading ? 'Updating...' : 'Update Vaccination'}
            </button>
            <button 
              type="button" 
              className="btn btn-secondary"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default EditVaccination;